// extracted by mini-css-extract-plugin
export var label = "_q6-0";
export var link = "_q6-1";